import { Injectable } from '@angular/core';
import { BROWSER_TYPE, DEVICE_TYPE, INSPECTION_REPORT_STATUS_CODE } from '../app.constants';
import { ApplicationError } from '../_errors/application-error';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class UtilsService {
  private isUpdate$: Subject<string>;
  public isUpdate: Observable<string>;

  constructor() {
    this.isUpdate$ = new Subject();
    this.isUpdate = this.isUpdate$.asObservable();
  }


  convertStringArray2Urlparameter(params: string[]): string {
    let urlString = '';
    params.forEach(param => urlString += '/' + param);
    return urlString;
  }

  download(blob: Blob, filename: string, reportId: string): void {
    if (!blob || !blob.type) {
      throw new ApplicationError('Blob is invalid.');
    }
    if (!filename) {
      throw new ApplicationError('Filename is invalid.');
    }

    const browserName = this.getBrowserName();
    if (browserName === BROWSER_TYPE.SAFARI) {
      if (reportId === null) {
        reportId = '0';
      }
      window.open(window.URL.createObjectURL(blob), 'child' + reportId);
    } else {
      const a = document.createElement('a');
      a.download = filename;
      a.href = window.URL.createObjectURL(blob);
      a.click();
    }
  }

  // browser nameを判定
  getBrowserName(): string {
    const ua: string = window.navigator.userAgent.toLowerCase();

    if (ua.indexOf('edge') !== -1) {
      return BROWSER_TYPE.EDGE;
    } else if (ua.indexOf('chrome') !== -1) {
      return BROWSER_TYPE.CHROME;
    } else if (ua.indexOf('safari') !== -1) {
      return BROWSER_TYPE.SAFARI;
    } else if (ua.indexOf('firefox') !== -1) {
      return BROWSER_TYPE.FIREFOX;
    } else if (ua.indexOf('opera') !== -1) {
      return BROWSER_TYPE.OPERA;
    } else {
      return BROWSER_TYPE.OTHER;
    }
  }

  // device nameを判定
  getDeviceName(): string {
    const ua: string = window.navigator.userAgent;

    if (ua.indexOf('iPad') !== -1) {
      return DEVICE_TYPE.IPAD;
    } else if (ua.indexOf('iPhone') !== -1) {
      return DEVICE_TYPE.IPHONE;
    } else if (ua.indexOf('android') !== -1) {
      return DEVICE_TYPE.ANDROID;
    } else {
      return DEVICE_TYPE.OTHER;
    }
  }

  isSafari(browserName): boolean {
    return browserName === BROWSER_TYPE.SAFARI;
  }
  isEdge(browserName): boolean {
    return browserName === BROWSER_TYPE.EDGE;
  }
  isReportStatusEditing(reportStatus): boolean {
    return reportStatus === INSPECTION_REPORT_STATUS_CODE.EDITING;
  }
  isReportStatusCompleted(reportStatus): boolean {
    return reportStatus === INSPECTION_REPORT_STATUS_CODE.COMPLETED;
  }
  isDeviceNameIpad(deviceName): boolean {
    return deviceName === DEVICE_TYPE.IPAD;
  }
  isNullOrUndefined(val): boolean {
    return (val === undefined || val === null);
  }
  updateHeaderName() {
    this.isUpdate$.next('Updated');
  }
}
